module.exports = __webpack_public_path__ + "static/media/00_crisalide.b5caab23.jpg";